import React, { useEffect } from 'react'
import { scroller } from 'react-scroll'
import ReactGA from 'react-ga';
import { useSearchParams } from 'react-router-dom';
import Page from '../components/layouts/page/Page'
import FeaturesSection from '../sections/features-section/FeaturesSection'
import TeamSection from '../sections/team-section/TeamSection'
import WaitlistSection from '../sections/waitlist-section/WaitlistSection'
import WidgetSection from '../sections/widget-section/WidgetSection'
import DevHeroImageSection from '../sections/hero-image-section/developer/DevHeroImageSection';
import DataLakeHouse from '../sections/Darklay/DarkLay';
import DataComparison from '../sections/dataComparison/DataComparison';
import CrashReportComparison from '../sections/crash-report-comparison/CrashReportComparison';
import BugFixingSection from '../sections/bugFixing/BugFixing';
import GamingDna from '../sections/gamingDna/GamingDna';
import QaProccess from '../sections/qaProsess/QaProcess';
import { AnalysisSection } from '../sections/analyzationQA/Analyzation';

type Props = {}

function HomePage({}: Props) {
  let [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    ReactGA.pageview(window.location.pathname + window.location.search);
    if (searchParams.get('join') !== null) {
      scroller.scrollTo('waitlist', {
        offset: 100
      });
    }
  }, []);

  return (
    <Page>
      <DevHeroImageSection />
      <DataLakeHouse />
      <BugFixingSection />
      <DataComparison />
      <CrashReportComparison />
      <QaProccess />
      <AnalysisSection />
      <GamingDna />
      <WaitlistSection isDev={false} />
    </Page>
  )
}

export default HomePage